const EnumNewsItemTypes = {
    Chart: 10,
    Image: 20,
    Video: 30,
    Article: 40
}

export default EnumNewsItemTypes;